export default __webpack_public_path__ + "static/media/checkbox.fd59c68c.svg";